import { addMinutes, subMinutes, addHours, isValid } from 'date-fns';

declare global {
  interface Date {
    toUTC: () => Date;
    zone: (offset) => Date;
    formatDate: (
      lang: string,
      isDayOfWeekHidden: boolean,
      options?: any,
    ) => string;
    isValid: () => boolean;
  }
}

Date.prototype.toUTC = function (): Date {
  const offset = this.getTimezoneOffset();
  return Math.sign(offset) !== -1
    ? addMinutes(this, offset)
    : subMinutes(this, Math.abs(offset));
};

Date.prototype.zone = function (offset: number): Date {
  return addHours(this.toUTC(), offset);
};

Date.prototype.formatDate = function (
  locale: string,
  isDayOfWeekHidden: boolean = false,
  options = { month: 'short', day: '2-digit' },
): string {
  if (isDayOfWeekHidden) {
    options['weekday'] = 'short';
  }
  return this.toLocaleString(locale, options);
};

Date.prototype.isValid = function (): boolean {
  return isValid(this);
};
